import Vue from 'vue'

class GlobalEvent {
    constructor() {
        this._vue = new Vue()
    }

    get mail () {
        const $this = this

        return {
            on (callback) {
                $this._vue.$off('mail-status-refresh')
                $this._vue.$on('mail-status-refresh', callback)
            },
            handle(){
                $this._vue.$emit('mail-status-refresh')
            }
        }
    }
}
const globalEvent = new GlobalEvent()
export default globalEvent
